import axios, { AxiosResponse } from "axios";
import { InstitutionUrl } from "./AUrl";

/*
The interface for the response from the create institution endpoint.

@id: The institution ID.
@name: The name of the institution.
*/
export interface CreateInstitutionResponse {
    id: number;
    name: string;
}

/*
The interface for the API response.

@status: The HTTP status code.
@error: The error message if any.
@institution: The created institution if applicable.
*/
export interface CreateInstitutionApiResponse {
    status: number;
    error?: string;
    institution?: CreateInstitutionResponse;
}

// Function Signature
export type CreateInstitutionType = (
    jwt: string,
    name: string,
) => Promise<CreateInstitutionApiResponse>;

/*
The function to create an institution.

@jwt: The JWT of the user making the request.
@name: The name of the institution.

@returns: The ApiResponse from the create institution endpoint.
*/
export const createInstitution: CreateInstitutionType = async (jwt, name) => {
    const url = new InstitutionUrl().create_institution;
    if (!jwt) {
        return { status: 401, error: "JWT has expired" };
    }

    let response: AxiosResponse<any>;
    try {
        response = await axios.post<CreateInstitutionApiResponse | string>(
            url,
            { name },
            {
                headers: {
                    "Content-Type": "application/json",
                    token: jwt,
                },
                validateStatus: () => true, // Resolve promise for all HTTP status codes
            },
        );
    } catch (error) {
        return {
            status: 500,
            error: "Network or other error occurred",
        };
    }

    return response.status === 201
        ? {
              status: response.status,
              institution: response.data as CreateInstitutionResponse,
          }
        : { status: response.status, error: response.data as string };
};
